import { Component, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { effectiveDateNewTaxAddress } from 'environments/properties';
import 'fullpage.js/dist/jquery.fullpage.js';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public effectiveNewAddress;
  public lang: string;

  private langSubscription: Subscription;
  constructor(
    public dialog: MdDialog,
    private appConfigService: AppConfigService,
  ) {}

  ngOnInit() {
    const format = 'DD-MM-YYYY HH:mm';
    const now = moment(moment.utc().format(format), format).add(7, 'hours');
    this.effectiveNewAddress = now.isAfter(moment(effectiveDateNewTaxAddress, format));
    this.lang = this.appConfigService.getLanguage();
    this.langSubscription && this.langSubscription.unsubscribe();
    this.langSubscription = this.appConfigService.getLanguageObs()
      .subscribe(lang => this.lang = lang);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts